// extracted by mini-css-extract-plugin
module.exports = {"order-skeletons":"rOHVLE2-ScbucZfuCcXOs","order-item":"_2_x_bCsQaJKRnEbUcv7OFh","skeletons":"_1oYbSLygfFpKKn6oqOL0eO","loading":"_3UE3LATfPu-XOXWLZI2EZZ"};